export default __webpack_public_path__ + "static/media/layout-2.66d4ba93.jpg";